var map = {
	"./default/assets/SnappyIcon.svg": 9116,
	"./default/assets/font.css": 3525,
	"./default/assets/tailwind.css": 8261,
	"./demo/assets/font.css": 4609,
	"./demo/assets/images/color.png": 9122,
	"./demo/assets/images/hue.png": 5354,
	"./demo/assets/images/snappy_data.svg": 5589,
	"./demo/assets/images/snappy_elements.svg": 4013,
	"./demo/assets/images/snappy_flows.svg": 4715,
	"./demo/assets/logo.svg": 3551,
	"./driveplus/assets/font.css": 5115,
	"./driveplus/assets/images/color.png": 7985,
	"./driveplus/assets/images/hue.png": 2642,
	"./driveplus/assets/logo.svg": 1380,
	"./flow/assets/font.css": 9060,
	"./flow/assets/images/color.png": 8201,
	"./flow/assets/images/hue.png": 8725,
	"./flow/assets/images/snappy_data.svg": 2525,
	"./flow/assets/images/snappy_elements.svg": 8843,
	"./flow/assets/images/snappy_flows.svg": 6260,
	"./flow/assets/logo.svg": 1521,
	"./flyingtiger/assets/font.css": 3978,
	"./flyingtiger/assets/images/color.png": 7472,
	"./flyingtiger/assets/images/hue.png": 8156,
	"./flyingtiger/assets/images/snappy_data.svg": 3453,
	"./flyingtiger/assets/images/snappy_elements.svg": 920,
	"./flyingtiger/assets/images/snappy_flows.svg": 9497,
	"./flyingtiger/assets/logo.svg": 4786,
	"./gartenkultur/assets/font.css": 1306,
	"./gartenkultur/assets/images/color.png": 8774,
	"./gartenkultur/assets/images/hue.png": 7438,
	"./gartenkultur/assets/images/snappy_data.svg": 3447,
	"./gartenkultur/assets/images/snappy_elements.svg": 8186,
	"./gartenkultur/assets/images/snappy_flows.svg": 3769,
	"./gartenkultur/assets/logo.svg": 3314,
	"./gerstl/assets/font.css": 6480,
	"./gerstl/assets/images/color.png": 190,
	"./gerstl/assets/images/hue.png": 4755,
	"./gerstl/assets/logo.svg": 8290,
	"./impactsolutions/assets/font.css": 5383,
	"./impactsolutions/assets/images/color.png": 7633,
	"./impactsolutions/assets/images/hue.png": 2815,
	"./impactsolutions/assets/images/snappy_data.svg": 1082,
	"./impactsolutions/assets/images/snappy_elements.svg": 689,
	"./impactsolutions/assets/images/snappy_flows.svg": 9614,
	"./impactsolutions/assets/logo.svg": 4644,
	"./itmc/assets/font.css": 6960,
	"./itmc/assets/images/color.png": 4734,
	"./itmc/assets/images/hue.png": 8959,
	"./itmc/assets/logo.svg": 145,
	"./krediflow/assets/SnappyIcon.svg": 7750,
	"./krediflow/assets/font.css": 2665,
	"./krediflow/assets/tailwind.css": 3612,
	"./llm/assets/font.css": 2953,
	"./llm/assets/images/color.png": 7632,
	"./llm/assets/images/hue.png": 8946,
	"./llm/assets/images/snappy_data.svg": 1209,
	"./llm/assets/images/snappy_elements.svg": 2007,
	"./llm/assets/images/snappy_flows.svg": 1036,
	"./llm/assets/llm_diagram.png": 8448,
	"./llm/assets/logo.svg": 7806,
	"./mb/assets/font.css": 5497,
	"./mb/assets/images/color.png": 8441,
	"./mb/assets/images/hue.png": 5312,
	"./mb/assets/images/snappy_data.svg": 305,
	"./mb/assets/images/snappy_elements.svg": 7868,
	"./mb/assets/images/snappy_flows.svg": 2011,
	"./mb/assets/logo.svg": 7628,
	"./motolino/assets/SnappyIcon.svg": 4947,
	"./motolino/assets/font.css": 2311,
	"./motolino/assets/images/color.png": 1472,
	"./motolino/assets/images/hue.png": 2573,
	"./motolino/assets/images/nx.png": 7015,
	"./motolino/assets/images/ny.png": 8047,
	"./motolino/assets/images/nz.png": 958,
	"./motolino/assets/images/px.png": 2433,
	"./motolino/assets/images/py.png": 5799,
	"./motolino/assets/images/pz.png": 4017,
	"./motolino/assets/logo.svg": 9119,
	"./motolino/assets/tailwind.css": 9786,
	"./neuraxis/assets/font.css": 113,
	"./neuraxis/assets/images/color.png": 561,
	"./neuraxis/assets/images/hue.png": 1215,
	"./neuraxis/assets/logo.svg": 3472,
	"./poc/assets/font.css": 1614,
	"./poc/assets/images/color.png": 1751,
	"./poc/assets/images/hue.png": 5780,
	"./poc/assets/images/snappy_data.svg": 9745,
	"./poc/assets/images/snappy_elements.svg": 8465,
	"./poc/assets/images/snappy_flows.svg": 3613,
	"./poc/assets/images/snappy_onyx_small.png": 4207,
	"./poc/assets/logo.svg": 9231,
	"./providebit/assets/font.css": 9215,
	"./providebit/assets/images/color.png": 4089,
	"./providebit/assets/images/hue.png": 139,
	"./providebit/assets/logo.svg": 5646,
	"./senler/assets/font.css": 902,
	"./senler/assets/images/color.png": 2561,
	"./senler/assets/images/hue.png": 6683,
	"./senler/assets/images/snappy_data.svg": 3539,
	"./senler/assets/images/snappy_elements.svg": 1736,
	"./senler/assets/images/snappy_flows.svg": 9777,
	"./senler/assets/logo.svg": 3335,
	"./snappy/assets/font.css": 6955,
	"./snappy/assets/images/color.png": 979,
	"./snappy/assets/images/hue.png": 8520,
	"./snappy/assets/images/snappy_bexio.svg": 1807,
	"./snappy/assets/images/snappy_data.svg": 4192,
	"./snappy/assets/images/snappy_ecommerce.svg": 9695,
	"./snappy/assets/images/snappy_elements.svg": 5942,
	"./snappy/assets/images/snappy_fintech.svg": 6094,
	"./snappy/assets/images/snappy_flows.svg": 8814,
	"./snappy/assets/images/snappy_invoice_automation.svg": 9860,
	"./snappy/assets/images/snappy_llm.svg": 9890,
	"./snappy/assets/images/snappy_pages.svg": 8133,
	"./snappy/assets/logo.svg": 948,
	"./snpy/assets/font.css": 8283,
	"./snpy/assets/images/color.png": 1101,
	"./snpy/assets/images/hue.png": 1832,
	"./snpy/assets/images/snappy_data.svg": 5519,
	"./snpy/assets/images/snappy_elements.svg": 3703,
	"./snpy/assets/images/snappy_flows.svg": 1205,
	"./snpy/assets/logo.svg": 3074,
	"./sprachtechnik/assets/font.css": 4041,
	"./sprachtechnik/assets/images/color.png": 1945,
	"./sprachtechnik/assets/images/hue.png": 5035,
	"./sprachtechnik/assets/logo.svg": 213,
	"./sprachtechnik/assets/swisswool_logo.png": 7544,
	"./sula/assets/font.css": 9993,
	"./sula/assets/images/color.png": 860,
	"./sula/assets/images/hue.png": 2362,
	"./sula/assets/logo.svg": 9072,
	"./swisswool/assets/font.css": 2042,
	"./swisswool/assets/images/color.png": 4784,
	"./swisswool/assets/images/hue.png": 4735,
	"./swisswool/assets/images/snappy_data.svg": 4364,
	"./swisswool/assets/images/snappy_elements.svg": 3112,
	"./swisswool/assets/images/snappy_flows.svg": 4564,
	"./swisswool/assets/logo.svg": 7208,
	"./uniska/assets/font.css": 6090,
	"./uniska/assets/images/color.png": 6407,
	"./uniska/assets/images/hue.png": 5037,
	"./uniska/assets/images/snappy_data.svg": 6028,
	"./uniska/assets/images/snappy_elements.svg": 946,
	"./uniska/assets/images/snappy_flows.svg": 7000,
	"./uniska/assets/logo.svg": 6294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4748;